import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagSl = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26.67,
	height: 22,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#0600f5",
			d: "M1 11H31V21H1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
			transform: "rotate(180 16 24)",
			fill: "#ea3323"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
			opacity: .15
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
			fill: "#fff",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.612,8.569c2.019-.889,4.318-.889,6.337,0,.331,4.68-.725,7.333-3.168,7.958-2.443-.625-3.499-3.278-3.168-7.958Z",
			fill: "#0600f5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.781,10.646l.767,1.534,.511-.682,1.278,1.705c0,.079-.011,.158-.033,.234-.356,1.245-1.299,2.237-2.524,2.656-1.225-.419-2.168-1.411-2.524-2.656-.022-.076-.033-.155-.033-.234l1.278-1.705,.511,.682,.767-1.534Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.372,8.68c.08-.038,.16-.075,.241-.111l.253,4.044c.108,1.728,1.266,3.213,2.915,3.74,1.65-.527,2.807-2.012,2.915-3.74l.253-4.044c.081,.036,.161,.073,.241,.111l-.247,3.949c-.116,1.859-1.378,3.448-3.162,3.984-1.784-.535-3.046-2.125-3.162-3.984l-.247-3.949Z",
			fill: "#ea3323"
		})
	]
});
const ForwardRef = forwardRef(SvgFlagSl);
export { ForwardRef as ReactComponent };
